import type { Pollster } from '../../data/surveys.types';
import './Surveys.css';

interface Props {
  pollster: Pollster;
}

export default function MethodologyCard({ pollster }: Props) {
  return (
    <article className="method-card" style={{ borderTopColor: pollster.color }}>
      <h3 className="method-card__h3">
        <span
          className="method-card__pill"
          style={{ background: pollster.abbr_bg }}
        >
          {pollster.abbr}
        </span>
        {pollster.fullname}
      </h3>
      {pollster.lead_analyst && (
        <p className="method-card__lead">{pollster.lead_analyst}</p>
      )}
      <dl className="method-card__dl">
        <dt>Sample</dt>
        <dd>{pollster.sample_typical}</dd>
        <dt>Margin error</dt>
        <dd>{pollster.moe}</dd>
        <dt>Method</dt>
        <dd>{pollster.method}</dd>
      </dl>
    </article>
  );
}
